import React from "react";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  DialogSystemGLPure,
  GridDocumentTrackingPure,
  HeaderHLPure,
  ButtonHLPure,
  GridSelectionHLPure,
} from "../../pures";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./document-tracking.css";

const DocumentTrackingView = (props) => {
  const { t } = useTranslation();

  // Container custom styles
  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    padding: "20px",
    width: "auto",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }
  const containerTableAndHeadersStyles = {
    marginTop: "20px",
    maxWidth: "100%",
    justifyContent: "start",
  };

  const documentCell = (props) => {
    return <td>
      <p>{props.dataItem}</p>
    </td>
  }

  const headerCell = (props) => {
    return <span className="DocumentTrackingView-title-text-request">{props.title}</span>;
  }

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <HeaderHLPure title={props.title} />

          <Grid
            container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            es={12}
            className="container-grid-tracking"
          >
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className="container-description"
            >
              <div className="text-detail-request">
                <p className="DocumentTrackingView-title-text-request">
                  {t("documentTracking.request")}
                </p>
                <p className="text-request">
                  {(props.signRequest.solicitudeName || props?.signRequest?.inbox?.solicitudeName) || "Ninguno"}
                </p>
              </div>
              <div className="text-detail-request">
                {
                  props.documents.length > 0
                    ? <div className={`DocumentTrackingView-document-list ${props.documents.length > 5 ? "scroll" : ""}`}>
                      <GridSelectionHLPure
                        skip={0}
                        take={props.documents.length}
                        pageable={false}
                        dataGrid={props.documents}
                        styleGrid={props.documents.length > 5 ? { maxHeight: '250px' } : null}
                        titleRow1={`${t("documentTracking.document")}(s):`}
                        headerColumnOne={headerCell}
                        cellColumnOne={documentCell}
                      />
                    </div>
                    : <>
                      <p className="DocumentTrackingView-title-text-request">
                        {t("documentTracking.document")}:
                      </p>
                      <p className="text-request">
                        {props.fileNameDoc || "Ninguno"}
                      </p>
                    </>
                }
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              className="container-document-tracking"
            >
              <GridDocumentTrackingPure
                dataStateChange={props.dataStateChange}
                {...props}
              />
            </Grid>
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
              className="btns-taxData"
            >
              <ButtonHLPure
                nameBtn={t("button.back")}
                onClickBtn={props.onBack}
              />
            </Grid>
            {/* Componet pure "Promotional footer" */}
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              style={containerTableAndHeadersStyles}
            >
              <PromotionalFooterPure />
            </Grid>
          </Grid>

          {/* Alerts of Notification Completed and Loadign */}
          <DialogSystemGLPure
            {...props}
            toggleLoadingRequesting={props.toggleLoadingRequesting}
            toggleCompletedRequesting={props.toggleCompletedRequesting}
            toggleErrorRequesting={props.toggleErrorRequesting}
          />
        </Container>
      )}
    </div>
  );
};

export { DocumentTrackingView as default };
